import React from "react";
import { useWallet } from "../context/WalletContext";
import { useToast } from "../components/common/ToastContext";
import Button from "../components/common/Button";
import BrandName from "../components/common/BrandName";
import { LOGO } from "../config/assets";

const FEATURES = [
  { ico: "▦", title: "12 Income Boards", sub: "From $5 to $10,240" },
  { ico: "⚡", title: "Up to 5x Returns", sub: "Per-board earning ceiling" },
  { ico: "⛓", title: "20-Level Rewards", sub: "Deep generation income" },
  { ico: "💸", title: "Instant USDT Payouts", sub: "Claim & withdraw anytime" },
];

export default function Connect() {
  const { connect, connecting } = useWallet();
  const toast = useToast();

  const handleConnect = async () => {
    try {
      await connect();
    } catch (e) {
      toast.error("Connection failed", e.message || "Could not connect wallet.");
    }
  };

  return (
    <div className="welcome">
      <div className="ambient"><i /><i /><i /></div>

      <div className="welcome-inner">
        <div className="welcome-logo-wrap">
          <span className="wl-ring" />
          <img className="welcome-logo" src={LOGO} alt="Nexaura" />
        </div>

        <h1 className="welcome-title"><BrandName /></h1>
        <div className="welcome-tag">Smart Investments, Limitless Future</div>

        <div className="welcome-features">
          {FEATURES.map((f, i) => (
            <div className="wf" key={i} style={{ animationDelay: `${0.1 + i * 0.08}s` }}>
              <span className="wf-ico">{f.ico}</span>
              <div className="wf-body">
                <div className="wf-title">{f.title}</div>
                <div className="wf-sub">{f.sub}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="welcome-cta">
        <Button loading={connecting} onClick={handleConnect}>
          {connecting ? "Connecting…" : "Connect Wallet"}
        </Button>
        <div className="welcome-hint">
          Open inside your wallet's DApp browser (Trust Wallet, MetaMask, Binance) for the best experience.
        </div>
      </div>
    </div>
  );
}
